<script lang="ts">
	import { clickOutside } from '../../../../../../../../../helpers/index.js';
  import { createEventDispatcher } from 'svelte'

  export let dragDisabled: boolean

  let isShowModalActions = false

  const dispatch = createEventDispatcher<{
    'mousedown': () => void,
    'touchstart': () => void,
    'keydown': () => void,
    'action': { type: string }
  }>()

  const actionHandler = (type: string) => {
    isShowModalActions = false
    dispatch('action', { type })
  }
</script>

<i 
  class="icon-drag" 
  tabindex={dragDisabled ? 0 : -1} 
  aria-label="drag-handle"
  style={dragDisabled ? 'cursor: grab' : 'cursor: grabbing'}
  on:mousedown={() => dispatch('mousedown')} 
  on:touchstart={() => dispatch('touchstart')}
  on:keydown={() => dispatch('keydown')}
  on:click={() => isShowModalActions = !isShowModalActions}
  use:clickOutside
  on:click_outside={() => isShowModalActions = false}
>
  {#if isShowModalActions}
    <div class="modal-actions" on:click|stopPropagation={() => actionHandler('moveUp')}>
      <div class="action">
        <i class="icon-arrow-left-small" />
        <div class="action-name">Переместить выше</div>
      </div>
      <div class="action" on:click|stopPropagation={() => actionHandler('moveDown')}>
        <i class="icon-arrow-left-small second-arrow" />
        <div class="action-name">Переместить ниже</div>
      </div>

      <hr />

      <div class="action" on:click|stopPropagation={() => actionHandler('delete')}>
        <i class="icon-trash" />
        <div class="action-name">Удалить</div>
      </div>
    </div>
  {/if}
</i>

<style lang="scss">
  .icon-drag {
    position: absolute;
    top: 0;
    font-size: 13px;
    left: -21px;
  }

  .modal-actions {
    box-shadow: 0px 2px 10px 0px #30333D42;
    background-color: white;
    padding: 16px;
    border-radius: 8px;
    width: 209px;
    margin-top: 10px;
    box-sizing: border-box;
    z-index: 999999999;
    position: relative;

    hr {
      margin: 0 0 8px 0;
      border-color: #EFF1FD;
    }

    .action {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .action-name {
        color: #22252C;
        font-size: 16px;
        line-height: 23px;
        margin-left: 14px;
      }

      i {
        font-size: 16px;

        &.icon-trash {
          color: #FA624B;
        }

        &.icon-arrow-left-small {
          color: #2B50ED;
          transform: rotate(90deg);

          &.second-arrow {
            transform: rotate(-90deg);
          }
        }

        &::before {
          margin: 0;
        }
      }
    }
  }
</style>